import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import emailjs from '@emailjs/browser';

const ContactInner = () => {
    const form = useRef();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);

    const sendEmail = (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus(null);

        emailjs.sendForm(
            'service_c1h9c4m', // EmailJS servis ID
            'template_g8jfbpq', // EmailJS template ID
            form.current,
            'PRKd876EcsSi6JTA5' // EmailJS public key
        )
            .then((result) => {
                console.log(result.text);
                setSubmitStatus('success');
                form.current.reset();
            }, (error) => {
                console.log(error.text);
                setSubmitStatus('error');
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    return (
        <>


            <div className="contact-area space">
                <div className="container">
                    <div className="contact-page-wrap bg-theme">
                        <div className="row gy-40 align-items-center">
                            <div className="col-lg-4 col-md-6">
                                <div className="contact-info">
                                    <div className="contact-info_icon">
                                        <i className="fas fa-phone-alt" />
                                    </div>
                                    <div className="contact-info_details">
                                        <h6 className="contact-info_title">Phone</h6>
                                        <p className="contact-info_text">
                                            <span>+90 (322) 555-5555</span> <br />
                                            <span>+90 (322) 555-5555</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="contact-info">
                                    <div className="contact-info_icon">
                                        <i className="fas fa-map-marker-alt" />
                                    </div>
                                    <div className="contact-info_details">
                                        <h6 className="contact-info_title">Location</h6>
                                        <p className="contact-info_text">
                                            YÜZÜNCÜYIL MAH. 85028 SK. 01360 <br /> Adana / Turkey
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="contact-info">
                                    <div className="contact-info_icon">
                                        <i className="fas fa-envelope" />
                                    </div>
                                    <div className="contact-info_details">
                                        <h6 className="contact-info_title">Email</h6>
                                        <p className="contact-info_text">
                                            <span>service@nextglobal.com.tr</span> <br />
                                            <span>service@nextglobal.com.tr</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="space-bottom">
                <div className="container">
                    <div className="row gy-40 justify-content-between">
                        <div className="col-lg-4">
                            <div className="title-area mb-0">
                                <span className="sub-title">
                                    <img src="assets/img/icon/title_left.svg" alt="shape" />
                                    Contact Us
                                </span>
                                <h2 className="sec-title style2">Get In Touch</h2>
                                <p className="mb-40">
                                    For over a decade, Next Global has been delivering reliable supply,
                                    construction, and heavy equipment solutions. With a strong track record of excellence, we have built
                                    lasting partnerships and earned the trust of our clients worldwide.{" "}
                                </p>
                            </div>
                        </div>

                        <div className="col-xl-6 col-lg-8">
                            <div className="contact-form">
                                <form ref={form} onSubmit={sendEmail}>
                                    <div className="row">
                                        <div className="col-md-6 form-group">
                                            <input
                                                type="text"
                                                name="user_name"
                                                placeholder="Your Name"
                                                className="form-control style-border"
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <input
                                                type="email"
                                                name="user_email"
                                                placeholder="Your Email"
                                                className="form-control style-border"
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <input
                                                type="tel"
                                                name="user_phone"
                                                placeholder="Phone Number"
                                                className="form-control style-border"
                                            />
                                        </div>
                                        <div className="col-md-6 form-group">
                                            <select
                                                name="subject"
                                                id="subject"
                                                className="form-select style-border"
                                                required
                                            >
                                                <option value="">Subject</option>
                                                <option value="General Inquiry">General Inquiry</option>
                                                <option value="Support">Support</option>
                                                <option value="Partnership">Partnership</option>
                                            </select>
                                            <i className="fas fa-angle-down" />
                                        </div>
                                        <div className="col-12 form-group">
                                            <textarea
                                                name="message"
                                                placeholder="Message here.."
                                                className="form-control style-border"
                                                required
                                            />
                                        </div>
                                        <div className="col-12 form-group mb-0">
                                            <button
                                                type="submit"
                                                className="global-btn w-100"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? 'Sending...' : 'Send Now'}
                                                <img src="assets/img/icon/right-icon.svg" alt="NextGlobal" />
                                            </button>

                                            {submitStatus === 'success' && (
                                                <div className="alert alert-success mt-3">
                                                    Message sent successfully!
                                                </div>
                                            )}

                                            {submitStatus === 'error' && (
                                                <div className="alert alert-danger mt-3">
                                                    Failed to send message. Please try again.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="map-sec">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3185.007070738483!2d35.23985217627801!3d37.0334777545142!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x15288843e18a8665%3A0x6eb27c420c2a5815!2zWcO8esO8bmPDvHnEsWwsIDg1MDI4LiBTay4sIDAxMTcwIMOHdWt1cm92YS9BZGFuYQ!5e0!3m2!1str!2str!4v1744147388696!5m2!1str!2str"
                    width="400" height="300" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
                ></iframe>

                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9012.947784315404!2d35.4314007507132!3d36.9964764171299!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x152891006b27e84f%3A0xad576fc36bb85d36!2sIncirlik%20Air%20Base!5e0!3m2!1str!2str!4v1744148129062!5m2!1str!2str"
                    width="600" height="450" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
            </div>
        </>
    );
};

export default ContactInner;